import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { TherapistAction } from '../../actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

const {
  GET_RECURRING_APPOINTMENT_COUNT_REQUEST,
  GET_RECURRING_APPOINTMENT_COUNT_SUCCESS,
  GET_RECURRING_APPOINTMENT_COUNT_FAILURE,
} = TherapistAction;

function* getRecurringAppointmentCount(action: any): SagaReturnType<any> {
  try {
    const response = yield call(
      therapistSchedulingServices.getRecurringAppointmentCount,
      action.payload
    );
    if (response?.status === 200 || response?.status === 201) {
      yield put({ type: GET_RECURRING_APPOINTMENT_COUNT_SUCCESS, payload: response.data });
    } else {
      console.error('Unexpected response status:', response?.status);
      throw response.data;
    }
  } catch (error) {
    console.error('Get Recurring Appointment Count Error:', error);
    yield put({ type: GET_RECURRING_APPOINTMENT_COUNT_FAILURE, payload: error });
  }
}

function* getRecurringAppointmentCountSaga() {
  yield takeEvery(GET_RECURRING_APPOINTMENT_COUNT_REQUEST, getRecurringAppointmentCount);
}

export default getRecurringAppointmentCountSaga;
